import { render, staticRenderFns } from "./ot-checkbox-group.vue?vue&type=template&id=67f41bc6&scoped=true&"
import script from "./ot-checkbox-group.vue?vue&type=script&lang=ts&"
export * from "./ot-checkbox-group.vue?vue&type=script&lang=ts&"
import style0 from "./ot-checkbox-group.vue?vue&type=style&index=0&id=67f41bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f41bc6",
  null
  
)

export default component.exports